import * as React from "react";

import CenteredLayout from "../components/Centered";
import Loading from "../components/Loading";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchLoggedInUser } from "../store/slices/authSlice";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
  path: string;
}

export const PrivateRoute = ({ component: Component }: PrivateRouteProps) => {
  const dispatch = useAppDispatch();
  const hasUser = useAppSelector((state) => !!state.auth.user);

  React.useEffect(() => {
    if (!hasUser) {
      dispatch(fetchLoggedInUser());
    }
  }, [hasUser, dispatch]);

  return hasUser ? (
    <Component />
  ) : (
    <CenteredLayout>
      <Loading />
    </CenteredLayout>
  );
};
